import React from 'react';
import BaseModal from '../baseModal';

const ComingSoonModal = ({ show, setShow }) => {
  return (
    <BaseModal show={show} setShow={setShow} handleClose={() => setShow(false)}>
      <div className="broadcast-modal-tx__buttons">
          <h2>Coming Soon...</h2>
      </div>
    </BaseModal>
  )
}

export default ComingSoonModal;